import React from 'react';

import Box from '@mui/system/Box';

import { NavMenu } from './NavMenu';

export const Layout: React.FunctionComponent = ({ children }) => {
  return (
    <div>
      <NavMenu />
      <Box>{children}</Box>
    </div>
  );
};
